import { type ReactNode } from "react";
import styles from "./TabBar.module.css";

export interface TabItem {
  key: string;
  label: string;
  icon: ReactNode;
  badge?: number | string;
}

export interface TabBarProps {
  items: TabItem[];
  active: string;
  onChange: (key: string) => void;
  /** When true, renders as macOS sidebar instead of bottom tab bar */
  variant?: "auto" | "tabs" | "sidebar";
}

export function TabBar({ items, active, onChange, variant = "auto" }: TabBarProps) {
  const cls = variant === "sidebar" ? styles.sidebar : variant === "tabs" ? styles.tabs : styles.autoTabs;
  return (
    <nav className={[styles.root, cls].join(" ")} aria-label="Main">
      {items.map((item) => (
        <button
          key={item.key}
          className={[styles.item, item.key === active ? styles.active : ""].join(" ")}
          aria-current={item.key === active ? "page" : undefined}
          onClick={() => onChange(item.key)}
        >
          <span className={styles.icon}>{item.icon}</span>
          <span className={styles.label}>{item.label}</span>
          {item.badge != null && item.badge !== 0 && (
            <span className={styles.badge}>{item.badge}</span>
          )}
        </button>
      ))}
    </nav>
  );
}